module.exports = __webpack_public_path__ + "media/student_v2/assets/images/calendar_check-aedbd45175f61ddad0853892e37b613e.svg";